/* Server-rendered deduplication needs only empty-wrapper cleanup, never a body rewrite. */
(function () {
  'use strict';
  function tidy(root) {
    var body = root.querySelector('.blog__article__content');
    if (!body) return;
    body.querySelectorAll('[data-knc-duplicate]').forEach(function (marker) {
      if (marker.dataset.kncTidied) return;
      marker.dataset.kncTidied = 'true';
      // Remove adjacent spacing left by that specific image, not intentional article spacing elsewhere.
      ['previousSibling', 'nextSibling'].forEach(function (direction) {
        var node = marker[direction];
        while (node && (node.nodeType === 3 && !node.textContent.trim() || node.nodeType === 1 && node.tagName === 'BR')) {
          var next = node[direction];
          node.remove();
          node = next;
        }
      });
      var parent = marker.parentElement;
      while (parent && parent !== body && parent.matches('p,h2,h3,h4,figure,picture,a,span,div')) {
        if (parent.textContent.trim() || parent.querySelector('img,video,iframe,svg,form,input,button,table,hr')) break;
        parent.setAttribute('data-knc-empty', '');
        parent.hidden = true;
        parent = parent.parentElement;
      }
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-knc-article]')) tidy(scope);
    scope.querySelectorAll('[data-knc-article]').forEach(tidy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}());
